<tun-search-to-add-content-view
  [playlist]="playlist"
  [canReceiveFocus]="canReceiveFocus"
  (back)="onBack()"
  class="wrapper"
>

</tun-search-to-add-content-view>
